// extracted by mini-css-extract-plugin
export default {"header":"header_header__lOwdN","div":"header_div__ENzBQ","logo":"header_logo__dpz63","font":"header_font__u6T6Z"};